import './Card.css';

const Card = (props) => {
    const { id, cardType, name, imgUrl, updateFilter, toggleCursor } = props;
    
    return (
        <figure 
            className={cardType === 'portrait' ? 'card-m' : 'card-s'}
            onClick={() => updateFilter(id !== 0 ? id : name)}
            
        >
            <img className='fig-image' src={imgUrl} alt={name} 
                onMouseOver={() => toggleCursor(true)}
                onMouseOut={() => toggleCursor(false)}
            />
            <figcaption className='fig-caption' id='caption'
            >
                {/* {
                    isIntl ? <FormattedMessage
                        id={name}
                        defaultMessage={name}
                    /> : name
                } */}
                {name}
            </figcaption>
        </figure>
    )
};

export default Card;